export const HEADER_WHATSAPP_CALLS_BUTTON_ROOT_ID = 'header-whatsapp-calls-button';
export const HEADER_WHATSAPP_CALLS_PHONE_ICON_ID = 'header-whatsapp-calls-phone-icon';
